import { css } from 'styled-components';
import { grid, gridUnit } from '../../theme/utils/grid/grid';
import { BreakpointQueryName } from '../../theme/breakpoints';
import { TypographyName } from '../../theme/typography';
import { getTypography } from '../../theme/utils';
export const contentStyle = _ref => {
  let {
    theme
  } = _ref;
  return css(["", ""], grid(theme));
};
export const boxStyle = _ref2 => {
  let {
    theme
  } = _ref2;
  return css(["", " ", " align-items:center;&:last-child{margin-top:", ";", "{margin-top:0;}}"], gridUnit(theme, {
    size: {
      MD: 1 / 2
    }
  }), getTypography(theme, TypographyName.BODY), theme.spaceUnits.mobile.SMALL, theme.breakpoints.up(BreakpointQueryName.MD));
};
export const performanceTitle = css(["font-weight:bold;"]);
//# sourceMappingURL=EnergyBlock.style.js.map